import { useEffect, useState } from "react";
import { orderWidgets } from "../../../../../../utils/widgets";
import scriptLoader from "../../../../../../utils/scriptLoader";
import submit from "submit-form";
import SvgIcon from "../../../../../../parts/SvgIcon";
import ConfirmationModal from "../../../../../../parts/modals/ConfirmationModal";
import { truncateText } from "../../../../../../utils/string-helpers";

/**
 * Publish a widget
 * @param {*} e
 * @param {*} id
 */
const publishWidget = (id) => {
  submit(`/actions/widgets/publish/${id}`, {
    method: "GET",
  });
};

/**
 * Unpublish a widget
 * @param {*} e
 * @param {*} id
 */
const unpublishWidget = (id) => {
  submit(`/actions/widgets/unpublish/${id}`, {
    method: "GET",
  });
};

/**
 * Change the status of a widget
 * @param {*} param0
 * @returns
 */
const WidgetToggle = ({ status, id }) => {
  const [value, setValue] = useState(status === "draft" ? false : true);
  const [openedConfirmationModal, setOpenedConfirmationModal] = useState(false);

  const handleChange = () => {
    !value ? unpublishWidget(id) : publishWidget(id);
    setTimeout(() => {
      setOpenedConfirmationModal(false);
    }, 500);
  };
  return (
    <>
      <img
        className="toggle-button only-show-mobile"
        src={`/img/new-icons/toggle${value ? "_on" : "_off"}.svg`}
        alt="unpublish"
        onClick={() => {
          setValue(!value);
          setOpenedConfirmationModal(!openedConfirmationModal);
        }}
        style={{ position: "relative" }}
      />
      <input
        className="mobile-hidden"
        type="checkbox"
        id={`switch-${id}`}
        name={`switch-${id}`}
        role="switch"
        onChange={() => {
          setValue(!value);
          setOpenedConfirmationModal(!openedConfirmationModal);
        }}
        checked={value ? true : undefined}
      />
      <ConfirmationModal
        title={!value ? "Unpublish" : "Publish"}
        contentText={`Are you sure you want to ${
          !value ? "unpublish" : "publish"
        } this widget?`}
        cancelButtonText="Cancel"
        cancelButtonAction={() => {
          setOpenedConfirmationModal(false);
          setValue(!value);
        }}
        confirmButtonText={!value ? "Unpublish" : "Publish"}
        confirmButtonAction={() => handleChange(id)}
        isOpen={openedConfirmationModal}
      />
    </>
  );
};

export const WidgetsListManager = ({ locals }) => {
  const widgets = locals.widgets || locals.widgetsOrganization; //all the widgets

  const [isOrdering, setIsOrdering] = useState(false); //state to control if the widgets in widget manager are in edit mode or change order mode
  const [orderedWidgets, setOrderedWidgets] = useState([]); //array of widget's ids to reorder them
  const [refreshList, setRefreshList] = useState(false);
  /**
   * Reorder the widgets
   */
  useEffect(() => {
    scriptLoader(
      "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js",
      () => {
        const dragImage = document.createElement("img");
        dragImage.src =
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        const sortable = new Sortable(
          document.querySelector(".principal-grabber-div"),
          {
            animation: 350,
            handle: ".drag-wrapper",
            setData(dataTransfer) {
              dataTransfer.setDragImage(dragImage, 0, 0);
            },
            onEnd: (e) => {
              if (e.oldIndex === e.newIndex) return;

              const newOrderedWidgets = Array.from(
                document.querySelectorAll(".item-grabber-container")
              ).map((w) => w.id);

              setOrderedWidgets(newOrderedWidgets);
            },
          }
        );
      }
    );
  }, []);

  const handleSaveReorder = () => {
    if (orderedWidgets.length > 0) {
      submit("/actions/widgets/reorder", {
        method: "POST",
        body: {
          orderedWidgets,
        },
      });
    }
    setIsOrdering(false);
  };
  const cancelReorder = () => {
    setOrderedWidgets([]);
    setRefreshList(!refreshList);
    setIsOrdering(false);
  };
  return (
    <>
      <section>
        <header>
          <h4>Widgets Manager</h4>
          {!isOrdering && (
            <button
              data-button-type="secondary"
              onClick={() => setIsOrdering(true)}
            >
              Change order
            </button>
          )}
          {isOrdering && (
            <div role="buttons-container">
              <button
                data-button-type="secondary"
                data-action="cancel"
                onClick={cancelReorder}
              >
                Cancel
              </button>
              <button
                data-button-type="primary"
                onClick={handleSaveReorder}
                disabled={orderedWidgets.length === 0}
              >
                Save
              </button>
            </div>
          )}
        </header>
        <div className="principal-grabber-div principal-explore">
          {widgets &&
            orderWidgets(widgets).map(
              ({ _id, description, icon, name, status, type }) => (
                <article
                  key={`${_id}-${refreshList}`}
                  id={_id}
                  className="widget-manage-card item-grabber-container"
                >
                  {isOrdering && (
                    <div className="drag-wrapper">
                      <SvgIcon
                        className="drag-handle"
                        src={"/img/new-icons/drag.svg"}
                        noFilterOnLight={true}
                      />
                    </div>
                  )}
                  <div className="body">
                    <SvgIcon src={`/img/widget-icons/${icon}.svg`} />
                    <div>
                      <p className="s2">{truncateText(name, 35)}</p>
                      <p className="p4">{truncateText(description, 20)}</p>
                    </div>
                  </div>
                  <footer>
                    <button
                      data-button-type="text"
                      className="s2 clipped"
                      onClick={() => {
                        submit(`/actions/refresh/?`, {
                          method: "GET",
                          body: {
                            widget: _id,
                            section: "manager",
                            type,
                          },
                        });
                      }}
                    >
                      <span>Edit Widget</span>
                    </button>
                    <WidgetToggle status={status} id={_id} />
                  </footer>
                </article>
              )
            )}
          {/* add new widget */}
          <a
            href={`/actions/refresh?modal[type]=create-widget`}
            className="widget-manage-card add-box"
          >
            <SvgIcon src={"/img/new-icons/add-outline.svg"} />
            <p className="p4">Add New Widget</p>
          </a>
        </div>
      </section>
    </>
  );
};
